import { useState, useCallback } from 'react';
import { Dayjs } from 'dayjs';
import { PMReportFilters } from '../../../services/ReportingService';

export function usePMReportFilters() {
  const [centerId, setCenterId] = useState('');
  const [category, setCategory] = useState('');
  const [fromDate, setFromDate] = useState<Dayjs | null>(null);
  const [toDate, setToDate] = useState<Dayjs | null>(null);
  const [appliedFilters, setAppliedFilters] = useState<PMReportFilters>({});

  const handleApplyFilters = useCallback(() => {
    setAppliedFilters({
      centerId: centerId || undefined,
      category: category || undefined,
      fromDate: fromDate ? fromDate.format('YYYY-MM-DD') : undefined,
      toDate: toDate ? toDate.format('YYYY-MM-DD') : undefined,
    });
  }, [centerId, category, fromDate, toDate]);

  const handleResetFilters = useCallback(() => {
    setCenterId('');
    setCategory('');
    setFromDate(null);
    setToDate(null);
    setAppliedFilters({});
  }, []);

  return {
    centerId, setCenterId,
    category, setCategory,
    fromDate, setFromDate,
    toDate, setToDate,
    appliedFilters,
    handleApplyFilters,
    handleResetFilters,
  };
}
